var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VuePerfectScrollbar',{staticClass:"lm-workspace"},[_c('div',{staticClass:"lm-container"},[_c('WorkspaceColumns'),_c('WorkspaceLayout',{attrs:{"size":_vm.size},on:{"updated":_vm.updated}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }